import { Button } from "@aurumiq/ui/components/button";
import { isRouteErrorResponse, Link, useRouteError } from "react-router";

export function ForbiddenPage() {
  return (
    <div className="grid min-h-[60vh] place-items-center text-center">
      <div>
        <h1 className="font-bold text-3xl">403</h1>
        <p className="mt-2 text-muted-foreground">
          Your staff role does not grant access to this area.
        </p>
        <Button asChild variant="outline" className="mt-4">
          <Link to="/">Back to dashboard</Link>
        </Button>
      </div>
    </div>
  );
}

export function NotFoundPage() {
  return (
    <div className="grid min-h-[60vh] place-items-center text-center">
      <div>
        <h1 className="font-bold text-3xl">404</h1>
        <p className="mt-2 text-muted-foreground">Nothing here.</p>
        <Button asChild variant="outline" className="mt-4">
          <Link to="/">Back to dashboard</Link>
        </Button>
      </div>
    </div>
  );
}

export function RouteErrorPage() {
  const err = useRouteError();
  const message = isRouteErrorResponse(err)
    ? `${err.status} ${err.statusText}`
    : err instanceof Error
      ? err.message
      : "Unexpected error";
  return (
    <div className="grid min-h-screen place-items-center p-4 text-center">
      <div>
        <h1 className="font-bold text-xl">Something went wrong</h1>
        <pre className="mt-2 rounded bg-muted p-3 text-left text-xs">{message}</pre>
        <Button asChild variant="outline" className="mt-4">
          <Link to="/">Back to dashboard</Link>
        </Button>
      </div>
    </div>
  );
}
